import { render, staticRenderFns } from "./CreateLeaveGroup.vue?vue&type=template&id=73ae256a"
import script from "./CreateLeaveGroup.vue?vue&type=script&lang=js"
export * from "./CreateLeaveGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports